import useMutationCreateDeployKeys from './useMutationCreateDeployKeys';
import useMutationDeleteDeployKeys from './useMutationDeleteDeployKeys';
import useQueryActiveDeployKeys from './useQueryActiveDeployKeys';

const useDeployKeys = () => {
  const { isLoading: isLoadingKeys, keys } = useQueryActiveDeployKeys();
  const {
    isLoading: isCreatingKey,
    mutateAsync: createKey,
  } = useMutationCreateDeployKeys();
  const {
    isLoading: isDeletingKey,
    mutateAsync: deleteKey,
  } = useMutationDeleteDeployKeys();

  return {
    createKey,
    deleteKey,
    isCreatingKey,
    isDeletingKey,
    isLoadingKeys,
    keys,
  };
};

export default useDeployKeys;
